import React from 'react'
import styled from 'styled-components'
import BaseInput from './Input'

export const Root = styled.div`
  margin: ${props => props.margin};
  padding: ${props => props.padding};
  position: relative;
  width: 100%;
`

export const Input = styled(({ fakeDisabled, ...props }) => <BaseInput {...props} />)`
  &.MuiInputBase-root.Mui-disabled,
  &.MuiInputBase-root.Mui-disabled .MuiInputBase-input {
    cursor: ${props => (props.fakeDisabled ? 'not-allowed' : 'default')};
  }

  &.MuiInputBase-root.Mui-disabled {
    background-color: ${props => (props.fakeDisabled ? props.theme.palette.gray[95] : props.theme.palette.brand.white)};
    color: ${props => (props.fakeDisabled ? props.theme.palette.brand.disableFont : props.theme.palette.gray[20])};
  }
`

export const Browse = styled(({ size, ...props }) => <button {...props} />)`
  align-items: center;
  background-color: ${props => props.theme.palette.blue[50]};
  border: 0;
  border-radius: 0;
  color: ${props => props.theme.palette.brand.white};
  cursor: pointer;
  display: flex;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 13px;
  height: 100%;
  justify-content: center;
  outline: 0;
  padding: 0 10px;
  width: auto;

  &:focus {
    outline: 0;
  }

  &:hover {
    background-color: ${props => props.theme.palette.blue[35]};
  }

  &:disabled,
  &[disabled] {
    background-color: ${props => props.theme.palette.gray[85]};
    border-color: ${props => props.theme.palette.gray[85]};
    cursor: not-allowed;
    pointer-events: none;
    user-select: none;
  }
`

export const NativeInput = styled.input`
  display: none;
`
